import ThreeCardLayout, { ThreeCardLayoutProps } from '@/components/_rebrand/ThreeCardLayout';
import SerifAndSansSerifHeadline, { HeadlineFromCraftProps } from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import { StyleOverride } from '@/types/craft-style-overrides';
import Image from 'next/image';

const displayProps = {
  header: null,
  cards: [],
  exploreTitle: null,
  exploreItems: [],
  exploreImages: null,
  styleOverrides: undefined,
} as ThreeCardLayoutProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  width: number;
  height: number;
}

interface FeatureListItemFromCraft {
  destinationUrl: string;
  label: string;
  iconImage: AssetImageFromCraft;
}

interface ModuleProductAllFeatures {
  header: HeadlineFromCraftProps;
  featureListItems: FeatureListItemFromCraft[];
  mainImage: AssetImageFromCraft;
  secondaryImageLeft: AssetImageFromCraft;
  secondaryImageRight: AssetImageFromCraft;
  styleOverrides?: StyleOverride;
}

const formImages = (images: AssetImageFromCraft[]): ThreeCardLayoutProps['exploreImages'] => {

  return <>
    <div className="flex mb-[16px]">
      <Image src={images[0][0].url} width={images[0][0].width} height={images[0][0].height} alt={images[0][0].title} />
    </div>
    <div className="flex">
      <div className="flex mr-[16px]">
        <Image src={images[1][0].url} width={images[1][0].width} height={images[1][0].height} alt={images[1][0].title} className="rounded-[12px]" />
      </div>
      <div className="flex">
        <Image src={images[2][0].url} width={images[2][0].width} height={images[2][0].height} alt={images[2][0].title} />
      </div>
    </div>
  </>
}

const formIcon = (image: AssetImageFromCraft): React.ReactNode => {
  const data = Array.isArray(image) ? image[0] : image;

  return <Image src={data.url} width={data.width} height={data.height} alt={data.title} />
}

const formFeatureListItems = (features: FeatureListItemFromCraft[]): ThreeCardLayoutProps['exploreItems'] => {
  const items: ThreeCardLayoutProps['exploreItems'] = features.map((feature) => ({
    icon: formIcon(feature.iconImage),
    title: feature.label,
    link: feature.destinationUrl ? feature.destinationUrl : '',
  }));

  return items;
}

const setDynamicDisplayPropAttributes = (data: ModuleProductAllFeatures, isFlexModule: boolean) => {
  displayProps.exploreTitle = isFlexModule ? <SerifAndSansSerifHeadline {...data.header} /> : <SerifAndSansSerifHeadline {...data.header[0]} />
  displayProps.exploreImages = formImages([data.mainImage, data.secondaryImageLeft, data.secondaryImageRight]);
  displayProps.exploreItems = formFeatureListItems(data.featureListItems);

  displayProps.styleOverrides = {
    bottomMarginSpacing: 'none',
    topMarginSpacing: 'none'
  };
};

const AllFeatures = ({ entry }) => {
  if (entry.__typename === 'comparisonModules_allFeatures_BlockType') {
    const data = {
      header: {
        primarySansSerif: entry.headerSansSerif,
        secondarySerif: entry.headerSerif
      }, ...entry
    };

    setDynamicDisplayPropAttributes(data, true);
    return (
      <ThreeCardLayout {...displayProps} />
    );
  }

  const data = Array.isArray(entry?.moduleProductAllFeatures)
    ? entry.moduleProductAllFeatures[0]
    : entry?.moduleProductAllFeatures;

  setDynamicDisplayPropAttributes(data, false);

  return (
    <ThreeCardLayout {...displayProps} />
  );
};

export default AllFeatures;
